/**
 * Reusable Card component
 */

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export function Card({ children, className = '' }: CardProps) {
  return (
    <div className={`card-af overflow-hidden ${className}`}>
      {children}
    </div>
  );
}
